import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function lettersOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value as string;
    const isValid = /^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ\s]+$/.test(value);
    return isValid ? null : { lettersOnly: true };
  };
}
